import {JackpotBetWidgetHighlightedTextMRGBox} from "./jackpot-bet-widget-highlighted-text.mrgreen.box";

export const JackpotBetWidgetHighlightedTextMRGCisBox = JackpotBetWidgetHighlightedTextMRGBox;